import React from 'react';
import BackButton from '../components/BackButton';
import Footer from '../components/Footer';
import Reveal from '../components/Reveal';

const Privacy = () => {
  return (
    <>
      <main className="flex-grow w-full max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop pb-12 md:pb-16 pt-28 md:pt-32">
        <BackButton />
        <Reveal>
        <div className="max-w-3xl mx-auto">
          <header className="mb-12 text-center">
            <h1 className="font-display-lg text-display-lg-mobile md:text-[40px] text-primary mb-4">Privacy Policy</h1>
            <p className="font-body-lg text-body-lg text-on-surface-variant">How we handle and protect your data.</p>
          </header>
          
          <div className="bg-surface-container-lowest rounded-2xl p-8 md:p-12 border border-outline-variant/30 shadow-[0_8px_30px_rgba(0,0,0,0.04)] space-y-8">
            <section>
              <h2 className="font-headline-md text-headline-md text-on-surface mb-4 flex items-center gap-2">
                <span className="material-symbols-outlined text-primary">security</span>
                Data Collection
              </h2>
              <p className="text-on-surface-variant font-body-md leading-relaxed">
                At TankCare, we take your privacy seriously. We only collect essential information required to provide you with premium tank cleaning and maintenance services. This includes your contact details, service address, and appointment history.
              </p>
            </section>
            
            <section>
              <h2 className="font-headline-md text-headline-md text-on-surface mb-4 flex items-center gap-2">
                <span className="material-symbols-outlined text-primary">lock</span>
                Data Security
              </h2>
              <p className="text-on-surface-variant font-body-md leading-relaxed">
                Your personal and service data is securely stored using industry-standard encryption. We do not share, sell, or rent your personal information to third parties under any circumstances.
              </p>
            </section>
          </div>
        </div>
        </Reveal>
      </main>
      
      {/* Footer */}
      <Footer />
    </>
  );
};

export default Privacy;
